import { render, staticRenderFns } from "./CookieConsentBannerButton.vue?vue&type=template&id=48e8dc4e&scoped=true"
import script from "./CookieConsentBannerButton.vue?vue&type=script&lang=ts"
export * from "./CookieConsentBannerButton.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsentBannerButton.vue?vue&type=style&index=0&id=48e8dc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8dc4e",
  null
  
)

export default component.exports